const investTagClassificationAMFLang = {
	mix_funds: {
		tag: 'invest.tag.classification_amf.mix_funds',
		fr: 'Fonds diversifiés',
		en: 'Mix funds',
	},
	equities_euro_zone: {
		tag: 'invest.tag.classification_amf.equities_euro_zone',
		fr: 'Actions de pays de la zone euro',
		en: 'Equities from euro zone countries',
	},
	bonds_debt_euro: {
		tag: 'invest.tag.classification_amf.bonds_debt_euro',
		fr: 'Obligations et autres titres de créance internationaux',
		en: 'Bonds and other international debt securities',
	},
};

export default investTagClassificationAMFLang;
